<template>
  <StandardFlexBox
    direction="column"
    class="pa-1"
    height="270px"
    >
    {{getStepName}} ({{steps.length}})
      <StandardStep
        v-for="(step, index) in steps"
        :key="step_type + index"
        :step="step"
        :step_type="step_type"
        :location="step_type === 'worksteps'? 'taktplan_edit' : ''"
        :readonly="true"
        :text_color="work_package.textcolor"
        width="100%"
      />
  </StandardFlexBox>
</template>
<script>
  import { WorkBenchWorkPackageInfoBoxMixin} from '@/mixins/WorkBenchWorkPackageInfoBox.mixin.js'
  export default {
    props: ['step_type'],
    mixins: [
      WorkBenchWorkPackageInfoBoxMixin,
    ],
    data: () => ({
    }),
    computed: {
      getStepName: function () {
        return this.step_type.substring(0, this.step_type.indexOf("steps")).toUpperCase() + ".steps";
      }
    },
  }
</script>
<style>
  .class {

  }
</style>
